import { useEffect, useState } from "react";
import { getTransCodesAll } from "utils/api/lookupApi";
import { OptionRenderType } from "controls/global/stewart-checkbox/StewartAutocompleteWithCheckboxes";

// Trans-code dropdown options sourced from /lookup/GetTransCodesAll.
// Response is a flat string[] — each entry is used as both label and value.
export function useTransCodeOptions(): OptionRenderType[] {
  const [options, setOptions] = useState<OptionRenderType[]>([]);
  useEffect(() => {
    let mounted = true;
    getTransCodesAll().then((rows) => {
      if (!mounted) return;
      setOptions(rows.map((s) => ({ label: s, value: s })));
    });
    return () => {
      mounted = false;
    };
  }, []);
  return options;
}
